<div class="avatar"
     [ngClass]="color">
  {{getFirstLetter() | uppercase}}
</div>
